import axios from 'axios';
import hideMessage from './HideMessage';
const DefaultHeader = { "authorization": "Token " + localStorage.getItem('student_authenticity_token') }
class Auth {
  constructor() {

    this.token = localStorage.getItem('student_authenticity_token')
    this.email = localStorage.getItem('username')

    this.getProfile = this.getProfile.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
  }

  getProfile(env) {
    axios.get(process.env.REACT_APP_STUDENT_API+'32', { headers: DefaultHeader }).then(res => {
      console.log(res.data)
      return res.data
    }).catch(error => {
      return {}
    })
  }
  isAuthenticated() {
    return (this.token != undefined && this.token != 'undefined' )
  }

  signIn(user) {
    let userData = user
    axios.post(process.env.REACT_APP_STUDENT_API+'/rest-auth/login/',JSON.stringify(userData),{headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then(res => {
      if (res.data['non_field_errors'] != undefined) {
              console.log(res.data['non_field_errors']);
            }else {
              localStorage.setItem('student_authenticity_token', res.data['key']);
              localStorage.setItem('username', userData.username);
              localStorage.setItem('login_modal', false)
              localStorage.removeItem('error');
              window.location.reload(true);
            }
      }).catch(error => {

      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  GetEmail(){
    return this.email
  }

  GetKey(user) {
    let userData = user
    axios.post(process.env.REACT_APP_API_HOST+'/api-token-auth/',userData,{headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then(res => {
      if (res.data['non_field_errors'] != undefined) {
        console.log(res.data['non_field_errors']);
      }else {
        localStorage.setItem('student_authenticity_token', res.data['token']);
        localStorage.setItem('username', userData.username);
        localStorage.removeItem('error');
        localStorage.setItem('login_modal', false);
        axios.get(process.env.REACT_APP_API_HOST+'/rest-auth/user/',{headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Token "+ localStorage.getItem('student_authenticity_token')
          },
        }).then(res => {
          if (res.data['non_field_errors'] != undefined) {
            console.log(res.data['non_field_errors']);
          }else {
            localStorage.setItem('student_id', res.data['pk']);
            localStorage.setItem('login_value', true);
            let path_name = window.location.pathname;
            window.location.reload(true);
          }
        })
      }
    }).catch(error => {
      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  loginUsingOTP(user){
    let userData = user
    axios.put(process.env.REACT_APP_API_HOST+'/students/otp/',userData,{headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    }).then(res => {
      if (res.data['error'] != undefined) {
        hideMessage.displayErrorMsg(res.data['error'])
      }else {
        localStorage.setItem('student_authenticity_token', res.data['token']);
        localStorage.setItem('username', userData.email);
        localStorage.setItem('login_modal', false)
        localStorage.removeItem('error');
        let path_name = window.location.pathname;
        if (path_name.indexOf('/products') > -1) {
          window.location.reload(true);
        }else {
          window.location = "/dashboard"
        }
      }
    }).catch(error => {
      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  generateOTP(user){
    let userData = user
    axios.post(process.env.REACT_APP_API_HOST+'/students/otp/',userData,{headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    }).then(res => {
      if (res.data['error'] != undefined) {
        hideMessage.displayErrorMsg(res.data['error'])
      }else {
        hideMessage.displaySuccessMsg('Please check your email for the OTP.')
      }
    }).catch(error => {
      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  forgotPassword(user){
    let userData = user
    axios.post(process.env.REACT_APP_API_HOST+'/rest-auth/password/reset/',userData,{headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
      }).then(res => {
      if (res.data['non_field_errors'] != undefined) {
        hideMessage.displayErrorMsg(res.data['non_field_errors'])
      }else {
        hideMessage.displaySuccessMsg('Please check your email for the password reset link.')
          // localStorage.setItem('student_authenticity_token', res.data['key']);
          // localStorage.setItem('username', userData.username);
          // localStorage.removeItem('error');
          // window.location.reload(true);
        }
      }).catch(error => {

      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  signUp(user) {
    let userData = user
    axios.post(process.env.REACT_APP_STUDENT_API,userData).then(res => {
      if (res.data['non_field_errors'] != undefined) {
              console.log(res.data['non_field_errors']);
            }else {
              localStorage.setItem('student_authenticity_token', res.data['key']);
              localStorage.setItem('username', userData.username);
              localStorage.removeItem('error');
              window.location.reload(true);
            }
      }).catch(error => {

      if(error.response){
        let error_messages = error.response.statusText + "<br>"
        for (var key in error.response.data){
          error_messages += error.response.data[key] + "<br>"
        }
        hideMessage.displayErrorMsg(error_messages)
      }
    });
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        this.idToken = authResult.idToken;
        this.profile = authResult.idTokenPayload;
        // set the time that the id token will expire at
        this.expiresAt = authResult.idTokenPayload.exp * 1000;
        resolve();
      });
    })
  }

  signOut() {
    // clear id token, profile, and expiration
    if (localStorage.getItem('student_authenticity_token') == undefined ){
      window.location.reload(true);
    }else{
      axios.get(process.env.REACT_APP_API_HOST+'/rest-auth/logout/',{ headers: { "Authorization": "Token " + localStorage.getItem('student_authenticity_token') }}).then(res => {
        this.idToken = null;
        this.profile = null;
        this.expiresAt = null;
        localStorage.removeItem('student_authenticity_token');
        localStorage.removeItem('username');
        localStorage.setItem('logout_value', true);
        window.location.reload(true);
      }).catch(error => {
        if(error.response){
          let error_messages = error.response.statusText + "<br>"
          for (var key in error.response.data){
            error_messages += error.response.data[key] + "<br>"
          }
          hideMessage.displayErrorMsg(error_messages)
        }
      });
    }
  }
}

const authClient = new Auth();

export default authClient;
